// extracted by mini-css-extract-plugin
export default {"container":"aY-z","title":"bY-z","link":"cY-z"};